export default __webpack_public_path__ + "static/media/QA.a242f546.PNG";